import { Localization, Form, Core, Drawer } from 'connex-cds';
import React from 'react';
import styled from 'styled-components';
import { useCompanySetup } from '../../../MasterDataProvider';
import DamageWaiver from './damage-waiver/DamageWaiver';
import { activeFormsAndWaiversArray } from '../../../getActiveForms';
import { useTicketContext } from '../../../TicketContext';
import { useFormsAndWaiversSetup } from '../../../MasterDataProvider';
import { useVehicleSetup } from '../../../MasterDataProvider';
import { useVehicleTypeSetup } from '../../../MasterDataProvider';

const Styled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const TicketDetailActions = ({ toggleEarlyAcceptance }) => {
  const { translateObjects } = Localization.useTranslateObjects();
  const { userLocale } = Localization.useLocalizationContext();

  const companySetup = useCompanySetup();
  const formsAndWaiversSetup = useFormsAndWaiversSetup();
  const vehicleSetup = useVehicleSetup();
  const vehicleTypeSetup = useVehicleTypeSetup();

  const { ticket } = useTicketContext();
  const { setFieldValue, values } = Form.useFormContext();
  const { openDrawer, closeDrawer } = Drawer.useDrawerContext();

  const disableDamageWaiverButton = React.useMemo(() => {
    return values?.damageWaiverDeclined || values?.damageWaiverSignature?.image;
  }, [values?.damageWaiverDeclined, values?.damageWaiverSignature]);

  const handleDamageWaiverClick = React.useCallback(() => {
    openDrawer({
      onClose: () => {
        setFieldValue('damageWaiverDeclined', '');
        setFieldValue('damageWaiverSignature', { signerName: '' });
        closeDrawer();
      },
      titleStringId: 'damageWaiver',
      component: <DamageWaiver />,
      width: '100%',
    });
  }, [closeDrawer, openDrawer, setFieldValue]);

  const activeFormsAndWaivers = React.useMemo(
    () =>
      activeFormsAndWaiversArray({
        ticket,
        formTypeCondition: 'DAMAGE',
        formsAndWaiversSetup,
        vehicleSetup,
        vehicleTypeSetup,
        companySetup,
        translateObjects,
        userLocale,
      }),
    [ticket, formsAndWaiversSetup, vehicleSetup, vehicleTypeSetup, companySetup, translateObjects, userLocale]
  );

  return (
    <Styled className="driver-instructions-buttons">
      <Core.Button
        type="primary"
        stringId="damageWaiver"
        onClick={handleDamageWaiverClick}
        data-testid="damageWaiver-button"
        disabled={disableDamageWaiverButton}
        hidden={!companySetup?.data?.isDamageWaiverEnabled || activeFormsAndWaivers?.length === 0}
      />
      <Core.Button
        type="primary"
        stringId="earlyAcceptance"
        onClick={() => {
          toggleEarlyAcceptance();
          console.log('toggleEarlyAcceptance');
        }}
        data-testid="early-acceptance-button"
        disabled={values?.signature?.image}
        hidden={!companySetup?.data?.isEarlySignatureEnabled}
      />
    </Styled>
  );
};
